import { Button } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  setMenuTitle,
  setShowMenu,
  setShowSubMenu,
} from "../../../redux/slices/common_slice";
import { routePaths } from "../../../routing/routePaths";

const SettingsCommonHeader = () => {
  const isMobile = window.innerWidth < 768;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { t } = useTranslation();
  const stepperStatus = useSelector((state) => state.common?.stepperStatus);
  const menuTitle = useSelector((state) => state.common?.menuTitle);

  const handleNavigation = () => {
    if (stepperStatus?.isExpenseCompleted) {
      navigate(routePaths.dashboard);
    } else if (stepperStatus?.isIncomeCompleted) {
      navigate(routePaths?.expenses);
    } else if (stepperStatus?.isProfileCompleted) {
      navigate(routePaths?.income);
    } else {
      navigate(routePaths?.onboarding);
    }
  };
  return (
    <div className="col-12 back-bar-with-title settings-back-bar position-relative">
      <Button
        className="btn back-arrow-btn shadow-none border-0"
        onClick={() => {
          
          dispatch(setShowSubMenu(true));
          dispatch(setShowMenu(true));
          if (params?.["*"] && isMobile) {
            if (
              menuTitle === t("commonStepper.section1") ||
              menuTitle === t("commonStepper.section2") ||
              menuTitle === t("commonStepper.section3")
            ) {
              navigate("/settings/edit-form");
              dispatch(setMenuTitle(t("settings.editForm")));
            } else {
              navigate("/settings");
              dispatch(setMenuTitle(t("settings.title")));
            }
          } else {
            handleNavigation();
          }
        }}
      >
        <img
          src="/assets/images/icons/back-arrow-with-bg.svg"
          alt=""
          className="img-fluid"
        />
      </Button>
      <h1 className="mb-0">{menuTitle || t("settings.title")}</h1>
    </div>
  );
};

export default SettingsCommonHeader;
